<template>
    <f7-navbar back-link="Back">
      <f7-nav-title>
        <f7-link href="/" style="padding-left: 0px">
          <img class="logo" src="/static/logo-soccer-sessions-white.svg" style="max-height: 20px;" />
        </f7-link>
    </f7-nav-title>
      <f7-nav-right>
        <f7-link href="/library/">
            <img height="20px" style="margin-left: 0px" src="/static/icons/bookcase-library.svg" alt />
          </f7-link>
        <f7-link href="/books/">
            <img height="20px" style="margin-left: 0px" src="/static/icons/books.svg" alt />
          </f7-link>
          <f7-link href="/favorites/">
            <img height="20px" style="margin-left: 0px" src="/static/icons/star-white.svg" alt />
          </f7-link>
        <f7-link panel-open="right"><span class="text-uppercase">{{ 'books.table_of_contents' | translate }}</span></f7-link>
        <f7-link panel-open="left"><img height="20px" src="/static/icons/menu.svg" alt style="margin-left: 0px;"></f7-link>
      </f7-nav-right>
    </f7-navbar>
</template>

<script>
import onbackbutton from '@/mixins/onBackButton.js';

export default {
  mixins: [onbackbutton],
  name: 'navbarbook',
}
</script>